import ThemeMaker from '../../components/thememaker'
import { Flex, Space, Table, Tag, Button, Switch } from 'antd';
import { config } from '../../utils/config';
import axios from 'axios';
import jwt_decode from "jwt-decode";
import React, { useState, useEffect } from 'react'
import { EditOutlined } from "@ant-design/icons";
import { HiPencilSquare } from "react-icons/hi2";
import { FaTrash } from "react-icons/fa";
import { useHistory } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { ToastContainer, toast } from 'react-toastify';
import { Modal, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { SizeData, ColourData, FabricData, daysData, UOMData, MaterialData, ShoeSizedata, SizeDataBoyGirl } from '../../utils/rawdata';


export default function Warehouse() {
  const history = useHistory();
  const Router = useHistory()
  const [isFandB, setisFandB] = useState(false)
  const { apiEndpoint, baseNodeapiUrl } = config;
  let rawToken = sessionStorage.getItem("token");
  var decode = jwt_decode(rawToken);
  const userObj = Array.isArray(decode?.data?.user) ? decode?.data?.user[0] : (decode?.data?.user || decode?.user || {});
  const sellerId = userObj?.seller_id ?? decode?.data?.seller_id ?? decode?.seller_id ?? sessionStorage.getItem("seller_id");
  const isSellerAdmin = String(sellerId) === "1" || Number(sellerId) === 1 || userObj?.seller_id === 1 || userObj?.seller_id === "1";
  const adminshowable = decode?.data?.user?.[0]?.parent_id ?? decode?.data?.user?.parent_id;
  // console.log("sdfghjkertyuidfgrtyufghj", typeof (adminshowable))
  const [data, setData] = useState([])
  const [loading, setLoading] = React.useState(true);
  const [loadingWarehouseId, setLoadingWarehouseId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [currentPage, setCurrentPage] = useState(() => {
    const savedPage = Number(localStorage.getItem("warehouse_current_page"));
    return Number.isInteger(savedPage) && savedPage > 0 ? savedPage : 1;
  });
  const [pageSize, setPageSize] = useState(() => {
    const savedPageSize = Number(localStorage.getItem("warehouse_page_size"));
    return [10, 20, 50].includes(savedPageSize) ? savedPageSize : 10;
  });

  useEffect(() => {
    localStorage.setItem("warehouse_current_page", String(currentPage));
    localStorage.setItem("warehouse_page_size", String(pageSize));
  }, [currentPage, pageSize]);

  const handleToggleWarehouseStatus = async (warehouseId, currentStatus) => {
    const newStatus = !currentStatus;
    setLoadingWarehouseId(warehouseId);

    try {
      const response = await axios({
        url: `${apiEndpoint}/snp/warehouse/enable-disable/${warehouseId}`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token") || rawToken}`,
        },
        data: {
          status: newStatus,
        },
      });

      if (response?.data?.status === true || response?.data?.status === 200 || response?.data?.success) {
        toast.success(response?.data?.message || `Warehouse ${newStatus ? "enabled" : "disabled"} successfully!`);
        setData((prevData) =>
          prevData.map((item) => {
            const id = item?.id || item?.warehouse_id;
            if (id == warehouseId) {
              return {
                ...item,
                status: newStatus ? 1 : 0,
              };
            }
            return item;
          })
        );
      } else {
        toast.error(response?.data?.message || "Failed to update warehouse status.");
      }
    } catch (error) {
      console.error("Error updating warehouse status:", error);
      toast.error(error?.response?.data?.message || error?.message || "Failed to update warehouse status.");
    } finally {
      setLoadingWarehouseId(null);
    }
  };

  const handleDeleteWarehouse = async (warehouseId) => {
    if (!warehouseId) {
      toast.error("Invalid Warehouse ID.");
      return;
    }
    if (!window.confirm("Are you sure you want to delete this warehouse?")) {
      return;
    }
    try {
      const response = await axios({
        url: `${apiEndpoint}/snp/warehouse/delete/${warehouseId}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "X-Custom-Authorization": `Bearer ${sessionStorage.getItem("token") || rawToken}`,
        }
      });

      if (response?.data?.status === true || response?.data?.status === 200 || response?.data?.success) {
        toast.success(response?.data?.message || "Warehouse deleted successfully!");
        setData((prevData) => prevData.filter((item) => (item?.id || item?.warehouse_id) != warehouseId));
        getAllwarehouse();
      } else {
        toast.error(response?.data?.message || "Failed to delete warehouse.");
      }
    } catch (error) {
      console.error("Error deleting warehouse:", error);
      toast.error(error?.response?.data?.message || error?.message || "Failed to delete warehouse.");
    }
  };

  const Sstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };

  const columns = [
    {
      title: "Sr no.",
      key: "index",
      width: 60,
      align: "center",
      render: (_, __, index) => (
        <span style={{ fontWeight: 600, color: "#64748B", fontSize: "13px" }}>
          {(currentPage - 1) * pageSize + index + 1}
        </span>
      ),
    },
    {
      title: "Warehouse Name",
      dataIndex: "warehouse_name",
      key: "warehouse_name",
      render: (text, record) => (
        <div className="d-flex align-items-center" style={{ gap: "8px" }}>
          <div
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              backgroundColor: "#EFF6FF",
              color: "#1D4ED8",
              border: "1px solid #BFDBFE",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              flexShrink: 0
            }}
          >
            <i className="fas fa-warehouse" style={{ fontSize: "13px" }}></i>
          </div>
          <span style={{ fontWeight: 600, color: "#0F172A", fontSize: "13px" }}>
            {text || record?.warehouse_name || "—"}
          </span>
        </div>
      ),
    },
    {
      title: "Warehouse Code",
      dataIndex: "warehouse_code",
      key: "warehouse_code",
      render: (text) => (
        <span
          style={{
            color: "#475569",
            fontWeight: 600,
            fontSize: "12.5px",
            fontFamily: "monospace"
          }}
        >
          {text || "—"}
        </span>
      ),
    },
    {
      title: "Contact Person",
      dataIndex: "warehouse_contact_no",
      key: "warehouse_contact_no",
      render: (text) => (
        <div className="d-flex align-items-center" style={{ gap: "6px", color: "#334155", fontSize: "13px" }}>
          <i className="far fa-user text-muted" style={{ fontSize: "12px", lineHeight: 1, display: "inline-flex", alignItems: "center" }}></i>
          <span style={{ lineHeight: 1 }}>{text || "—"}</span>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text) => (
        <div className="d-flex align-items-center" style={{ gap: "6px", color: "#334155", fontSize: "13px" }}>
          <i className="far fa-envelope text-muted" style={{ fontSize: "12px", lineHeight: 1, display: "inline-flex", alignItems: "center" }}></i>
          <span style={{ lineHeight: 1 }}>{text || "—"}</span>
        </div>
      ),
    },
    {
      title: "FSSAI License",
      dataIndex: "fssai_license_no",
      key: "fssai_license_no",
      render: (text) => (
        <span style={{ fontSize: "13px", color: text ? "#334155" : "#94A3B8" }}>
          {text || "—"}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (status) => (
        <span
          style={{
            backgroundColor: status ? "#DCFCE7" : "#F1F5F9",
            color: status ? "#15803D" : "#64748B",
            fontWeight: 600,
            padding: "3px 10px",
            borderRadius: "20px",
            fontSize: "12px"
          }}
        >
          {status ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      title: "Enabled",
      key: "enable_disable",
      align: "center",
      width: 100,
      render: (_, record) => {
        const isEnabled = Boolean(
          record?.status === true ||
          record?.status === 1 ||
          record?.status === "1" ||
          record?.status === "active" ||
          record?.status === "ENABLE" ||
          record?.status === "enable"
        );
        const warehouseId = record?.id || record?.warehouse_id;
        const isLoadingRow = loadingWarehouseId === warehouseId;

        return (
          <Switch
            checked={isEnabled}
            loading={isLoadingRow}
            disabled={isLoadingRow}
            onChange={() => handleToggleWarehouseStatus(warehouseId, isEnabled)}
            style={{
              backgroundColor: isEnabled ? "#16A34A" : "#94A3B8"
            }}
          />
        );
      },
    },
    ...(!isSellerAdmin ? [
      {
        title: "Action",
        key: "edit_action",
        align: "center",
        render: (_, record) => (
          <button
            type="button"
            className="btn btn-sm btn-outline-primary d-inline-flex align-items-center justify-content-center"
            style={{ borderRadius: "8px", width: "32px", height: "32px", padding: 0 }}
            onClick={() => handleEdit(record.id, record.location_id)}
            title="Edit Warehouse"
          >
            <HiPencilSquare size={16} />
          </button>
        ),
      }
    ] : []),
    // {
    //   title: "Delete",
    //   key: "delete_action",
    //   align: "center",
    //   render: (_, record) => {
    //     const id = record?.id || record?.warehouse_id;
    //     return (
    //       <button
    //         type="button"
    //         className="btn btn-sm btn-outline-danger d-inline-flex align-items-center justify-content-center"
    //         style={{ borderRadius: "8px", width: "32px", height: "32px", padding: 0 }}
    //         onClick={() => handleDeleteWarehouse(id)}
    //         title="Delete Warehouse"
    //       >
    //         <FaTrash size={14} />
    //       </button>
    //     );
    //   },
    // },
  ];

  const [file, setFile] = useState(null);
  const [shipmentModalOpen, setshipmentModalOpen] = useState(false);
  const [downloadCSVModalOpen, setdownloadCSVModalOpen] = useState(false);
  const fullUrl = window.location.host;

  const handleFandBImport = async () => {
    try {
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(worksheet);
          let dataToSend = json.filter((item) => item.name !== null)
          sendFandBDataToDb(dataToSend);
        };
        reader.readAsArrayBuffer(file);
      }
    } catch (error) {
      console.error('Error handling import:', error);
    }
  };

  const handleImportForProdXpressbazaar = async () => {
    try {
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          const headers = json[0];
          const rows = XLSX.utils.sheet_to_json(worksheet);

          let errors = [];
          let dataToSend = rows.filter(item => item.name !== null).map((item) => {
            const missingFields = headers.filter(header => {
              return (item[header] === null || item[header] === undefined) &&
                !['image1', 'image2', 'image3', 'image4', 'pf_brand_owner_FSSAI_license_no', 'transfer_price'].includes(header);
            });

            if (missingFields.length > 0) {
              const errorMessage = `Error in SKU: ${item.sku} - Missing fields: ${missingFields.join(', ')}`;
              errors.push(errorMessage);
              console.log(errorMessage);
              return null;
            }

            let tts = daysData.filter(items => items.name === item.time_to_ship);
            let rw = daysData.filter(items => items.name === item.return_window);
            let colourCode = item?.colour ? ColourData.filter(items => items.name === item.colour) : null;

            return {
              ...item,
              time_to_ship: tts[0]?.value,
              return_window: rw[0]?.value,
            };
          }).filter(item => item !== null);

          if (errors.length > 0) {
            const fileData = JSON.stringify(errors, null, 2);
            const blob = new Blob([fileData], { type: 'text/plain' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.download = 'error.txt';
            link.href = url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            toast.error("Found error in excel! Error file is downloaded.")
          } else {
            sendDataToDb(dataToSend);
            console.log("datatosend -----------", dataToSend)
          }
        };
        reader.readAsArrayBuffer(file);
      }
    } catch (error) {
      console.error('Error handling import:', error.message);
    }
  };

  async function sendDataToDb(jsonData) {
    let apE;
    if (fullUrl === "multipleselleradmin.thesellerapp.com") {
      apE = "importProducts"
    } else {
      apE = "importxpProducts"
    }
    try {
      setLoading(true);
      let result = await axios({
        url: `${apiEndpoint}/${apE}`,
        method: 'POST',
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: { "orders": jsonData },
      })
      setLoading(false);
      if (result.data.status == 200) {
        toast.success("Products added successfully !");
        setFile(null)
        document.getElementById('inputFile').value = ''
      } else {
        toast.error("Server Not Working, Please try later!");
      }
    } catch (error) {
      setLoading(false);
      toast.error("Server Not Working, Please try later!");
    }
  }

  async function sendFandBDataToDb(jsonData) {
    console.log("jsonData---->", jsonData)
    const payload = {
      items: jsonData
    }
    try {
      let result = await axios({
        url: `${baseNodeapiUrl}/cms/customization/import-csv`,
        method: 'POST',
        headers: {
          "token": `${sessionStorage.getItem("token")}`,
        },
        data: payload,
      })
      console.log("result----->", result)
    } catch (error) {
      console.log(error)
    }
  }

  const [isDownloadingSample, setIsDownloadingSample] = useState(false);
  const [isImporting, setIsImporting] = useState(false);

  // GET /snp/warehouse/sample-csv
  const handleDownloadSample = async () => {
    try {
      setIsDownloadingSample(true);
      const response = await axios.get(`${apiEndpoint}/snp/warehouse/sample-csv`, {
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token") || rawToken}`,
        },
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "warehouse_sample.csv");
      document.body.appendChild(link);
      link.click();
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
      window.URL.revokeObjectURL(url);
      toast.success("Sample CSV downloaded successfully!");
    } catch (error) {
      console.error("Download sample error:", error);
      toast.error("Failed to download sample file");
    } finally {
      setIsDownloadingSample(false);
    }
  };

  // POST /snp/warehouse/import
  const handleWarehouseImport = async () => {
    if (!file) {
      toast.error("Please select an Excel or CSV file first!");
      return;
    }

    const allowedExtensions = ["xlsx", "xls", "csv"];
    const fileExt = file.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(fileExt)) {
      toast.error("Invalid format! Please select a .xlsx, .xls, or .csv file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setIsImporting(true);
      const token = sessionStorage.getItem("token") || rawToken;
      const response = await axios({
        method: "POST",
        url: `${apiEndpoint}/snp/warehouse/import`,
        data: formData,
        headers: {
          "x-custom-authorization": `Bearer ${token}`,
        },
      });

      if (response?.data?.status === true || response?.data?.status === 200 || response?.data?.success) {
        toast.success(response?.data?.message || "Warehouse data imported successfully!");
        setFile(null);
        const inputEl = document.getElementById("inputFile");
        if (inputEl) inputEl.value = "";
        setshipmentModalOpen(false);
        getAllwarehouse();
      } else {
        toast.error(response?.data?.message || "Failed to import warehouse data.");
      }
    } catch (error) {
      console.error("Import error:", error);
      toast.error(error?.response?.data?.message || error?.message || "Failed to import warehouse file.");
    } finally {
      setIsImporting(false);
    }
  };

  const handleImport = (id, locationId) => {
    // history.push(`/importwarehouse/${id}/${locationId}`);
  };
  const handleEdit = (id, locationId) => {
    history.push(`/addwarehouse/${id}/${locationId}`);
  };
  function handleShipementModalClose() {
    setshipmentModalOpen(false);
  };

  const getAllwarehouse = async () => {
    setLoading(true);
    try {
      const response = await axios({
        url: `${apiEndpoint}/snp/warehouse/get`,
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "X-Custom-Authorization": `Bearer ${rawToken}`
        },
      });
      setData(response?.data?.data || []);
    } catch (error) {
      console.log("Error -------->", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchWarehouse = async (searchValue) => {
    const query = searchValue !== undefined ? searchValue : searchQuery;
    if (!query || !query.trim()) {
      getAllwarehouse();
      return;
    }
    setIsSearching(true);
    try {
      const response = await axios({
        url: `${apiEndpoint}/snp/warehouse/search`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Custom-Authorization": `Bearer ${sessionStorage.getItem("token") || rawToken}`,
        },
        data: {
          warehouse_name: query.trim()
        }
      });
      const resultData = response?.data?.data || (Array.isArray(response?.data) ? response.data : []);
      setData(resultData);
    } catch (error) {
      console.log("Error searching warehouse:", error);
      setData([]);
    } finally {
      setIsSearching(false);
    }
  };

  const handleSearchChange = (e) => {
    const rawVal = e.target.value;
    const formattedVal = rawVal
      .replace(/[^a-zA-Z0-9\s.,&'-]/g, "")
      .replace(/^\s+/, "")
      .replace(/\s{2,}/g, " ");
    setSearchQuery(formattedVal);
    setCurrentPage(1);
    if (!formattedVal || !formattedVal.trim()) {
      getAllwarehouse();
    } else {
      handleSearchWarehouse(formattedVal);
    }
  };

  useEffect(() => {
    getAllwarehouse();
  }, [])

  return (
    <ThemeMaker>
      <div className="container-fluid py-3 px-3">
        {/* Unified Header Card */}
        <div
          className="p-3 mb-3 bg-white border"
          style={{
            borderRadius: "12px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            position: "sticky",
            top: "10px",
            zIndex: 30
          }}
        >
          <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ gap: "16px" }}>
            <div>
              <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                <h2 className="m-0 font-weight-bold" style={{ fontSize: "1.25rem", color: "#0F172A", letterSpacing: "-0.3px" }}>
                  Warehouse Management
                </h2>
              </div>
              <span style={{ fontSize: "12px", color: "#64748B" }}>
                Manage warehouses, service locations, and activation status
              </span>
            </div>

            <div className="d-flex align-items-center flex-wrap" style={{ gap: "12px" }}>
              {/* Search Box - Auto Search on Change */}
              <div className="position-relative" style={{ minWidth: "260px", maxWidth: "320px" }}>
                <i
                  className="fas fa-search position-absolute text-muted"
                  style={{ left: "14px", top: "50%", transform: "translateY(-50%)", fontSize: "13px" }}
                ></i>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search warehouse..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                  onKeyDown={(e) => {
                    // Prevent leading space or consecutive spaces
                    if (e.key === " " && (!searchQuery || searchQuery.endsWith(" "))) {
                      e.preventDefault();
                    }
                    // Block special characters like @, #, $, %, ^, *, etc.
                    const allowedNavKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter", "Home", "End"];
                    if (!allowedNavKeys.includes(e.key) && !/[a-zA-Z0-9\s.,&'-]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    const pastedText = e.clipboardData?.getData("text") || "";
                    const sanitized = (searchQuery + pastedText)
                      .replace(/[^a-zA-Z0-9\s.,&'-]/g, "")
                      .replace(/^\s+/, "")
                      .replace(/\s{2,}/g, " ");
                    setSearchQuery(sanitized);
                    setCurrentPage(1);
                    if (!sanitized || !sanitized.trim()) {
                      getAllwarehouse();
                    } else {
                      handleSearchWarehouse(sanitized);
                    }
                  }}
                  style={{
                    paddingLeft: "36px",
                    paddingRight: isSearching ? "36px" : "12px",
                    borderRadius: "8px",
                    fontSize: "13px",
                    height: "38px",
                    border: "1px solid #E2E8F0"
                  }}
                />
                {isSearching && (
                  <i
                    className="fas fa-spinner fa-spin position-absolute text-primary"
                    style={{ right: "14px", top: "50%", transform: "translateY(-50%)", fontSize: "13px" }}
                  ></i>
                )}
              </div>

              {/* Action Buttons (Only when adminshowable is not 0) */}
              {adminshowable != 0 && adminshowable != null && adminshowable !== "0" ? (
                <>
                  {/* <button
                    type="button"
                    className="btn btn-sm d-flex align-items-center shadow-sm"
                    style={{
                      backgroundColor: "#FFFFFF",
                      border: "1.5px solid #CBD5E1",
                      borderRadius: "8px",
                      fontWeight: 600,
                      height: "38px",
                      padding: "0 16px",
                      gap: "6px",
                      fontSize: "13px",
                      color: "#475569"
                    }}
                    onClick={() => setshipmentModalOpen(true)}
                  >
                    <i className="fas fa-file-import" style={{ color: "#16A34A" }}></i> Import Warehouse
                  </button> */}

                  <button
                    type="button"
                    className="btn btn-sm btn-primary d-flex align-items-center shadow-sm"
                    style={{
                      backgroundColor: "#F97316",
                      borderColor: "#F97316",
                      borderRadius: "8px",
                      fontWeight: 600,
                      height: "38px",
                      padding: "0 18px",
                      gap: "6px",
                      fontSize: "13px"
                    }}
                    onClick={() => Router.push("/addwarehouse")}
                  >
                    <i className="fas fa-plus"></i> Add Warehouse
                  </button>
                </>
              ) : null}
            </div>
          </div>
        </div>

        {/* Table Container Card */}
        <div
          className="bg-white border"
          style={{
            borderRadius: "12px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            overflowY: "auto",
            maxHeight: "calc(100vh - 250px)",
            minHeight: "350px"
          }}
        >
          <div className="table-responsive p-3">
            <Table
              columns={columns}
              dataSource={data}
              rowKey={(record) => record?.id || record?.warehouse_id || record?.warehouse_code}
              loading={loading || isSearching}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50'],
                onChange: (page, size) => {
                  setCurrentPage(page);
                  setPageSize(size);
                },
                onShowSizeChange: (current, size) => {
                  setCurrentPage(1);
                  setPageSize(size);
                },
              }}
            />
          </div>
        </div>

        <Modal
          open={shipmentModalOpen}
          onClose={handleShipementModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={Sstyle} className="col-md-5 col-11">
            <div className="modal-content border-0" style={{ borderRadius: "12px" }}>
              <div className="modal-header p-3 d-flex align-items-center justify-content-between border-bottom" style={{ backgroundColor: "#F8FAFC" }}>
                <div>
                  <h6 className="modal-title m-0" style={{ fontWeight: 700, color: "#0F172A", fontSize: "15px" }}>
                    Import Using Excel File
                  </h6>
                  <span
                    className="text-primary"
                    style={{ cursor: isDownloadingSample ? "not-allowed" : "pointer", fontSize: "12px", fontWeight: 600 }}
                    onClick={!isDownloadingSample ? handleDownloadSample : undefined}
                  >
                    <i className={isDownloadingSample ? "fas fa-spinner fa-spin mr-1" : "fas fa-download mr-1"}></i>
                    {isDownloadingSample ? "Downloading..." : "Download Sample Excel"}
                  </span>
                </div>
                <button
                  type="button"
                  className="close border-0 bg-transparent"
                  onClick={handleShipementModalClose}
                  style={{ cursor: "pointer", fontSize: "20px", color: "#64748B" }}
                >
                  <CloseIcon />
                </button>
              </div>
              <div className="modal-body p-4">
                <div className="importingSection">
                  <label style={{ fontSize: "13px", fontWeight: 600, color: "#475569", marginBottom: "8px", display: "block" }}>
                    Select Excel / CSV File (.xlsx, .xls, .csv)
                  </label>
                  <input
                    type="file"
                    id="inputFile"
                    accept=".xlsx, .xls, .csv"
                    className="form-control"
                    style={{ fontSize: "13px", borderRadius: "8px", padding: "6px 10px" }}
                    onChange={(e) => {
                      setFile(e.target.files[0]);
                    }}
                  />
                  {file && (
                    <div className="mt-2 text-muted" style={{ fontSize: "12px" }}>
                      <i className="fas fa-file-excel mr-1 text-success"></i>
                      Selected: <strong>{file.name}</strong> ({(file.size / 1024).toFixed(1)} KB)
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer p-3 border-top" style={{ backgroundColor: "#F8FAFC" }}>
                <button
                  type="button"
                  className="btn btn-sm btn-light border mr-2"
                  style={{ borderRadius: "8px", fontWeight: 600, padding: "6px 16px" }}
                  onClick={handleShipementModalClose}
                  disabled={isImporting}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-primary d-inline-flex align-items-center"
                  style={{ backgroundColor: "#105293", borderColor: "#105293", borderRadius: "8px", fontWeight: 600, padding: "6px 20px", gap: "6px" }}
                  onClick={handleWarehouseImport}
                  disabled={isImporting || !file}
                >
                  {isImporting && <i className="fas fa-spinner fa-spin"></i>}
                  {isImporting ? "Importing..." : "Submit"}
                </button>
              </div>
            </div>
          </Box>
        </Modal>
      </div>
    </ThemeMaker >
  );
}